function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m421 30v301l-30 30h-330l-31-30v-301l31-30h330z",
  fill: "#444"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m421 181v150l-30 30h-330l-31-30v-150z",
  fill: "#292929"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m91 30h270v301h-270z",
  fill: "#27d8f6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m91 181h270v150h-270z",
  fill: "#3aaaff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m61 0v361h-15c-24.901 0-46-20.101-46-45v-271c0-24.901 21.099-45 46-45z",
  fill: "#f5f0eb"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m0 181h61v180h-15c-24.901 0-46-20.101-46-45z",
  fill: "#dcd2cd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m512 45v271c0 24.899-21.099 45-46 45h-75v-361h75c24.901 0 46 20.099 46 45z",
  fill: "#f5f0eb"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m512 181v135c0 24.899-21.099 45-46 45h-75v-180z",
  fill: "#dcd2cd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m417.4 271c-18.9 0-33.4 15-33.4 33.6v-30c0-18.6-15.5-33.6-34.4-33.6-18.6 0-33.6 15-33.6 33.6 0-19.2-15.901-33.6-33.6-33.6-18.9 0-33.4 15-33.4 33.6v-150c0-18.6-15.5-34.6-34.4-34.6-18.6 0-33.6 16-33.6 34.6v147.9c-34.2 6.899-60 37.2-60 73.5v30c0 74.399 60.601 136 135 136h60c74.399 0 135-61.601 135-136v-71.4c0-18.6-15-33.6-33.6-33.6z",
  fill: "#fed2a4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m451 304.6v71.4c0 74.399-60.601 136-135 136h-60c-74.399 0-135-61.601-135-136v-30c0-36.301 25.8-66.601 60-73.5v-91.5h68v93.6c0-18.6 14.5-33.6 33.4-33.6 17.699 0 33.6 14.399 33.6 33.6 0-18.6 15-33.6 33.6-33.6 18.9 0 34.4 15 34.4 33.6v30c0-18.6 14.5-33.6 33.4-33.6 18.6 0 33.6 15 33.6 33.6z",
  fill: "#ffbd86"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m466 151v60c0 8.399-6.599 15-15 15s-15-6.601-15-15v-60c0-8.401 6.599-15 15-15s15 6.599 15 15z",
  fill: "#27d8f6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m466 181v30c0 8.399-6.599 15-15 15s-15-6.601-15-15v-30z",
  fill: "#3aaaff"
});

var Svg024Onlinelearning = function Svg024Onlinelearning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg024Onlinelearning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/024-online learning.096e19e4.svg";
export { ForwardRef as ReactComponent };